import io from 'socket.io-client';
import { config } from '../config';
import CONSTANT from '../utils/constant';
import { getUserStorage } from '../utils/utils';
import {
  setGroupUnreadCount,
  setNewChatMessage,
  setRemovedChatGroup,
  setSocketReconnected,
  setUnreadMessageCount,
  setUpdateChatMessage,
} from './appSlice';

let socketConnection: any;
let storedDispatch: any;
let reconnectTimeout: any = null;
let lifecycleRegistered = false;
// Đã từng đứt kết nối kể từ lần đồng bộ gần nhất -> lần 'connect' tới là nối LẠI, phải đồng bộ.
let daTungDut = false;

export function initSocket() {
  return (dispatch: any) => {
    const user = getUserStorage();
    if (user) {
      if (user.token) {
        storedDispatch = dispatch;
        registerSocketEvents(dispatch, createSocketConnection());
        registerLifecycleListeners();
      }
    }
  };
}

function createSocketConnection() {
  const user = getUserStorage();
  // Đóng hẳn kết nối cũ trước khi dựng cái mới: mỗi lần rớt mạng mà cứ tạo thêm socket thì socket
  // cũ vẫn giữ listener và vẫn tự nối lại -> nhận event hai lần, đồng thời rò kết nối.
  if (socketConnection) {
    try {
      socketConnection.removeAllListeners();
      socketConnection.close();
    } catch (e) {
      console.log('close socket error', e);
    }
  }
  socketConnection = io(`${config.socketServerUrl}?token=${user.token}&app=web`, {
    reconnection: true,
    reconnectionDelay: 500,
    // KHÔNG giới hạn số lần thử nối lại. Bản cũ dừng sau 10 lần (~40 giây): chỉ cần mất mạng,
    // máy ngủ hoặc deploy lại chat service quá 40 giây là socket chết hẳn, webchat không nhận
    // tin nhắn realtime nữa cho tới khi người dùng F5.
    reconnectionAttempts: Infinity,
    reconnectionDelayMax: 5000,
    transports: ['websocket'],
    upgrade: false,
  });

  return socketConnection;
}

/** Dựng lại kết nối KÈM listener sau `delay` ms. */
function scheduleReconnect(reason: string, delay: number = 5000) {
  console.log('socket', reason);
  clearTimeout(reconnectTimeout);
  reconnectTimeout = setTimeout(() => {
    registerSocketEvents(storedDispatch, createSocketConnection());
  }, delay);
}

/**
 * Có mạng trở lại / quay lại tab mà socket đang đứt thì nối lại NGAY. Trình duyệt hay treo timer
 * của tab ẩn nên máy ngủ dậy thường rơi vào đúng cảnh này.
 */
function registerLifecycleListeners() {
  if (lifecycleRegistered || typeof window === 'undefined') {
    return;
  }
  lifecycleRegistered = true;

  const reconnectIfDead = () => {
    if (!socketConnection || socketConnection.connected) {
      return;
    }
    scheduleReconnect('reconnect on wake', 0);
  };

  window.addEventListener('online', reconnectIfDead);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      reconnectIfDead();
    }
  });
}

// function getSocketConnection() {
//   return socketConnection || createSocketConnection();
// }

function registerSocketEvents(dispatch: any, socket: any) {
  // const user = getUserStorage();
  socket.removeAllListeners();

  socket.on(CONSTANT.SOCKET_EVENT.MESSAGE_COUNT, (data: number) => {
    if (data > 0) {
      // const audioNotification = new Audio(AudioMessage);
      // audioNotification.play().then((r) => {});
    }
    dispatch(setUnreadMessageCount(data));
  });

  socket.on(CONSTANT.SOCKET_EVENT.NEW_MESSAGE, (data: any) => {
    if (data) {
      const newMsg = JSON.parse(data);
      if (
        newMsg.type !== 'system-adv' &&
        newMsg.type !== 'system' &&
        newMsg.type !== 'system-time'
        //  ||
        // Number(newMsg.message?.user_id) !== user.id
      ) {
        // const audioNotification = new Audio(AudioMessage);
        // audioNotification.play().then((r) => {});
      }
    }
    dispatch(setNewChatMessage(data));
  });

  socket.on(CONSTANT.SOCKET_EVENT.UPDATE_MESSAGE, (data: any) => {
    dispatch(setUpdateChatMessage(data));
  });

  // User bị xóa khỏi nhóm: nhận real-time để cập nhật UI ngay, không cần refresh.
  // removeAllListeners() ở đầu hàm đảm bảo không đăng ký trùng listener khi re-register.
  socket.on(CONSTANT.SOCKET_EVENT.CHAT_GROUP_REMOVED, (data: any) => {
    try {
      const payload = typeof data === 'string' ? JSON.parse(data) : data;
      if (payload && payload.group_id) {
        dispatch(setRemovedChatGroup(payload));
      }
    } catch (e) {
      console.log('CHAT_GROUP_REMOVED parse error', e);
    }
  });

  // Chính người dùng này vừa đọc một nhóm ở TAB KHÁC / THIẾT BỊ KHÁC: đồng bộ lại bộ đếm.
  // Web và app dùng chung một bộ đếm chưa đọc ở server (cả hai token đều ra user_type='web').
  //
  // Ưu tiên `unread_by_group` — ảnh chụp TOÀN BỘ bộ đếm do server tính, thay nguyên state là
  // mọi tab về đúng một con số. Cộng trừ từng nhóm (nhánh dưới) chỉ đúng khi tab nhận đủ mọi
  // event; lệch một lần là lệch mãi. Nhánh dưới giữ để còn chạy được với server bản cũ.
  socket.on(CONSTANT.SOCKET_EVENT.UNREAD_UPDATED, (data: any) => {
    try {
      const payload = typeof data === 'string' ? JSON.parse(data) : data;
      if (!payload) return;
      if (payload.unread_by_group) {
        dispatch(setUnreadMessageCount(payload.unread_by_group));
        return;
      }
      if (payload.group_id !== undefined) {
        dispatch(
          setGroupUnreadCount({
            groupId: Number(payload.group_id),
            unread: Number(payload.unread) || 0,
          }),
        );
      }
    } catch (e) {
      console.log('UNREAD_UPDATED parse error', e);
    }
  });

  // Nối lại được sau khi đứt: kéo lại dữ liệu đã lỡ trong lúc mất kết nối (bộ đếm chưa đọc,
  // danh sách nhóm, tin nhắn của nhóm đang mở) — xem Chat.tsx.
  socket.on('connect', () => {
    if (daTungDut) {
      daTungDut = false;
      dispatch(setSocketReconnected(Date.now()));
    }
  });

  socket.on('error', () => {
    daTungDut = true;
    scheduleReconnect('error');
  });

  socket.on('disconnect', () => {
    // KHÔNG dựng lại kết nối ở đây: socket.io tự nối lại trên chính socket này và listener vẫn
    // còn nguyên. Chỉ ghi nhận để khi nối lại thì đồng bộ dữ liệu đã lỡ.
    daTungDut = true;
    console.log('socket disconnected');
  });

  // socket.io đã thử hết số lần cho phép (chỉ xảy ra nếu sau này đặt lại reconnectionAttempts).
  socket.on('reconnect_failed', () => {
    daTungDut = true;
    scheduleReconnect('reconnect failed');
  });

  // 'terminated' là custom server event - cần tạo kết nối mới và re-register handlers
  socket.on('terminated', () => {
    daTungDut = true;
    scheduleReconnect('terminated');
  });
}
